import { render, staticRenderFns } from "./FormDetailOptions.vue?vue&type=template&id=64f302b4&scoped=true&"
import script from "./FormDetailOptions.vue?vue&type=script&lang=js&"
export * from "./FormDetailOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f302b4",
  null
  
)

export default component.exports